
import { REST_METHOD, REST_URL } from './../constants';
import { requestEmployeeBoarding } from './api';

const OnBoardingService = {
  checkNewJoiner: async (user_email: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}/${user_email}${REST_URL.CHECK}`,
        method: `${REST_METHOD.GET}`,
      };
      return await requestEmployeeBoarding(requestParams);
    } catch (error) {
      throw error;
    }
  },
  getNewJoinerInfo: async (user_email: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}/${user_email}`,
        method: `${REST_METHOD.GET}`,
      };
      return await requestEmployeeBoarding(requestParams);
    } catch (error) {
      throw error;
    }
  },

  getLeaverInfo: async (user_email: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.OFFBOARDINGS}/${user_email}`,
        method: `${REST_METHOD.GET}`,
      };
      return await requestEmployeeBoarding(requestParams);
    } catch (error) {
      throw error;
    }
  },
  
  getNewJoiners: async (manager_email?: string, page?: number, page_size?: number) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { manager_email, page, page_size}
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getListLeavers: async (manager_email?: string, page?: number, page_size?: number) => {
    try {
      const requestParams = {
        url: `${REST_URL.OFFBOARDING_BY_MANAGER}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { manager_email }
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteNewJoiner: async (id: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}/${id}`,
        method: `${REST_METHOD.DELETE}`,
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  cancelOffboarding: async (id: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.OFFBOARDINGS}/${id}`,
        method: `${REST_METHOD.DELETE}`,
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateLeaver: async (id: string, data: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.OFFBOARDINGS}/${id}`,
        method: `${REST_METHOD.PUT}`,
        data: data
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getListPersonaDefinition: async (id = '') => {
    try {
      const requestParams = {
        url: `${REST_URL.PERSONA_DEFINITIONS}/${id}`,
        method: `${REST_METHOD.GET}`,
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getNewJoinerTasks: async (joiner_id: string, params?: {
    status?: string;
    page_index?: number;
    page_size?: number;
  }) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}/${joiner_id}${REST_URL.TASKS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: params,
      };
      const res = await requestEmployeeBoarding(requestParams);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  
  updateNewJoinerTasks: async (data: Array<{ id: string, status: string }>) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}${REST_URL.TASKS}`,
        method: `${REST_METHOD.PUT}`,
        data: data,
      };
      const res = await requestEmployeeBoarding(requestParams);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  updateNewJoinerTasksList: async (joiner_id: string, data: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}/${joiner_id}${REST_URL.TASKS}`,
        method: `${REST_METHOD.PUT}`,
        data: data,
      };
      const res = await requestEmployeeBoarding(requestParams);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  getNewJoinerTasksList: async (joiner_id: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.NEW_JOINERS}/${joiner_id}${REST_URL.CHECK_LIST}`,
        method: `${REST_METHOD.GET}`,
      };
      const res = await requestEmployeeBoarding(requestParams);
      return res.data;
    } catch (error) {
      throw error;
    }
  },

  sendMailDayOne: async (id: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.USERS}/${id}${REST_URL.MAIL_DAY_ONE}`,
        method: `${REST_METHOD.POST}`,
      };
      const response = await requestEmployeeBoarding(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
export default OnBoardingService;
